import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap'; // Import GSAP
import style from '../../css/homepage/Landing.module.css';
import TradingViewTicker from './Ticker_stcck';
import { Link } from 'react-router-dom';

const Landingpage = () => {
  const texts = [
    "Most",
    "Highest",
    "Top"
  ];

  const [currentText, setCurrentText] = useState(texts[0]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const listRef = useRef(null); // Ref for the list
  const buttonRef2 = useRef(null); // Ref for the second button

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => {
        const nextIndex = (prevIndex + 1) % texts.length;
        setCurrentText(texts[nextIndex]);
        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useLayoutEffect(() => {
    if (listRef.current) {
      gsap.fromTo(
        listRef.current.children,
        {
          opacity: 0,
          y: 20,
        },
        {
          opacity: 1,
          y: 0,
          stagger: 0.3, // Add stagger effect to animate each list item one after the other
          duration: 1,
          ease: "power2.out"
        }
      );
    }

    if (buttonRef2.current) {
      gsap.fromTo(
        [buttonRef2.current],
        {
          opacity: 0,
          scale: 1.2,
        },
        {
          opacity: 1,
          scale: 1,
          stagger: 0.3, // Staggering the animation for buttons
          duration: 1,
          ease: "back.out(5.7)"
        }
      );
    }
  }, []); // No dependency on hover state anymore

  return (
    <div className="container-fluid" style={{ margin: '0px', padding: '0px' }}>
      <TradingViewTicker />
      <div className={`${style.landing_container} container`}>
        <div className="row">
          <div className={`col-lg-6 ${style.col_container} ${style.col_content_container}`}>
            <h1> India's  <span>{currentText}</span> <b> FOLLOWED  </b> <br /> Swing Trader </h1>

            <div className={style.text_landing_list}>
              <ul ref={listRef}>
                {/* <li><i className={` ${style.landing_icons} fa-solid fa-chart-simple `}></i> One click fundamental analysis</li>
                <li><i className={` ${style.landing_icons} fa-solid fa-magnifying-glass-chart `}></i> Premium scanners</li>
                <li><i className={` ${style.landing_icons} fa-solid fa-chart-line `}></i>Advanced swing strategies</li> */}
                <li><i className={` ${style.landing_icons} fa-solid fa-chart-simple `}></i> AI BASED FUNDAMENTAL ANALYSIS</li>
                <li><i className={` ${style.landing_icons} fa-solid fa-chart-line `}></i>ADVANCE PROFITABLE STRATEGIES</li>
                <li><i className={` ${style.landing_icons} fa-solid fa-people-group`}></i>EXCLUSIVE PREMIUM GROUP</li>
                <li><i className={` ${style.landing_icons} fa-solid fa-magnifying-glass-chart `}></i>ALGO INBUILT SCANNERS</li>
                {/* <li><i className={` ${style.landing_icons} fa-solid fa-fire`}></i>ALGO FNO SETUPS</li> */}
              </ul>
            </div>


            <div className={style.buttons_landing}>
               <Link to={"/Reg_pay"} > 
              <button className={style.button_lnd_1} >Buy Now</button>
               </Link>
            </div>
          </div>
          <div className={`col-lg-6 ${style.col_container} ${style.col_img_container}`}>
            <img src="/images/revenue-animate.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landingpage;
